import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/payjoy_logo.svg'


const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "extensions-message" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "message" }
const _hoisted_5 = {
  key: 1,
  class: "close-button-container"
}
const _hoisted_6 = { class: "providers-list" }
const _hoisted_7 = { class: "listing-titles" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "close-button-container" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "text-black" }
const _hoisted_12 = {
  key: 3,
  class: "loading-modal-overlay"
}
const _hoisted_13 = { class: "loading-modal" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "loading-modal-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageLoading = _resolveComponent("PageLoading")!
  const _component_CardItem = _resolveComponent("CardItem")!
  const _component_MarkdownRenderer = _resolveComponent("MarkdownRenderer")!
  const _component_HighlightPopup = _resolveComponent("HighlightPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showExtensionsMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "payjoy-top-banner" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "PayJoy"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            (_ctx.extensionsMessageIcon)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.extensionsMessageIcon,
                  alt: "Message icon"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.extensionsMessageTitle), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.extensionsMessageContent), 1)
            ]),
            (_ctx.extensionsMessageButtonText)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "primary extension-continue-button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.extensionsRetry && _ctx.extensionsRetry(...args)), ["stop"]))
                  }, _toDisplayString(_ctx.extensionsMessageButtonText), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.showExtensionsMessage)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "payjoy-top-banner" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "PayJoy"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.t("why-do-you-need-extension")), 1),
            (_ctx.extensionReasons.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensionReasons, (reason) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: reason.reasonKey,
                        class: _normalizeClass({ 'extension-option--selected': _ctx.selectedExtensionReason === reason.reasonKey })
                      }, [
                        _createVNode(_component_CardItem, {
                          title: _ctx.t(reason.title),
                          "right-icon": _ctx.selectedExtensionReason === reason.reasonKey ? _ctx.checkboxSelectedIcon : _ctx.checkboxEmptyIcon,
                          "right-icon-alt": "Select option",
                          onClick: ($event: any) => (_ctx.selectedExtensionReason = reason.reasonKey)
                        }, null, 8, ["title", "right-icon", "onClick"])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "primary extension-continue-button",
              disabled: !_ctx.selectedExtensionReason || _ctx.disableButton,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectExtensionReason && _ctx.selectExtensionReason(...args)))
            }, _toDisplayString(_ctx.t("continue")), 9, _hoisted_10)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_HighlightPopup, {
      "is-visible": _ctx.showPopup,
      "popup-class": _ctx.popupClass,
      "add-close-icon": true,
      "button-text": _ctx.modalButtonText,
      "button-color": "#222926",
      "image-src": _ctx.extensionModalImage,
      onClosePopup: _ctx.onClosePopup,
      onDismissPopupCloseBtn: _ctx.onDismissPopupCloseBtn
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.extensionModalTitle), 1),
        _createVNode(_component_MarkdownRenderer, {
          content: _ctx.extensionModalContent1,
          tag: "p",
          class: "extension-modal-content"
        }, null, 8, ["content"]),
        _createVNode(_component_MarkdownRenderer, {
          content: _ctx.extensionModalContent2,
          tag: "p",
          class: "extension-modal-content"
        }, null, 8, ["content"])
      ]),
      _: 1
    }, 8, ["is-visible", "popup-class", "button-text", "image-src", "onClosePopup", "onDismissPopupCloseBtn"]),
    (_ctx.showLoadingModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "popup-close-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLoadingModal = false))
            }, [
              _createElementVNode("img", {
                src: _ctx.closeSmallBlackIcon,
                alt: "Close"
              }, null, 8, _hoisted_14)
            ]),
            _createElementVNode("img", {
              src: _ctx.loadingIconGreen,
              alt: "Loading",
              class: "loading-modal-icon"
            }, null, 8, _hoisted_15),
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.t("loading")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}